import { useSearchParams } from 'react-router-dom'
import { TableProps } from 'antd'

type Params = {
  searchFields?: Array<string>
  filterFields?: Array<string>
  sorterFields?: Array<string>
  usePagination?: boolean
}

export const useTableSearchParams = ({
  searchFields,
  filterFields,
  sorterFields,
  usePagination = false,
}: Params) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const handleTableChange: TableProps<any>['onChange'] = (
    pagination,
    filters,
    sorter,
  ) => {
    const params = new URLSearchParams(searchParams)

    if (usePagination) {
      params.set('page', String(pagination.current ?? 1))
      params.set('limit', String(pagination.pageSize ?? 10))
    }

    const searchFieldsSet = new Set(searchFields)
    const filterFieldsSet = new Set(filterFields)
    const sorterFieldsSet = new Set(sorterFields)

    Array.from(params.keys()).forEach((key) => {
      if (
        key === 'sorterField' ||
        key.startsWith('searchField_') ||
        key.startsWith('filterField_')
      ) {
        params.delete(key)
      }
    })

    Object.entries(filters).forEach(([field, values]) => {
      if (!values?.length) return

      if (searchFieldsSet.has(field)) {
        params.set(`searchField_${field}`, String(values[0]))
        return
      }

      if (filterFieldsSet.has(field)) {
        params.set(`filterField_${field}`, values.map(String).join(','))
      }
    })

    const currentSorter = Array.isArray(sorter) ? sorter[0] : sorter
    if (currentSorter.columnKey)
      sorterFieldsSet.add(String(currentSorter.columnKey))

    if (
      currentSorter?.field &&
      currentSorter.order &&
      (sorterFieldsSet.has(String(currentSorter.field)) ||
        sorterFieldsSet.has(String(currentSorter.columnKey)))
    ) {
      params.set(
        'sorterField',
        currentSorter.order === 'descend'
          ? `-${String(currentSorter.columnKey ?? currentSorter.field)}`
          : String(currentSorter.columnKey ?? currentSorter.field),
      )
    }

    setSearchParams(params)
  }

  return handleTableChange
}
